// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__15BNO","header":"style_header__Tur5l","timelineContainer":"style_timelineContainer__3ns7D","score":"style_score__6rdL6"};